<template>
  <media-changed :log-entry="logEntry" :meta="meta" :resource-type="resourceType"></media-changed>
</template>
<script>
import MediaChanged from '@kanrisha/components/AppEventLog/Events/MediaChanged';

export default {
  components: {
    MediaChanged,
  },
  props: {
    logEntry: {
      type: Object,
      default: () => {},
    },
    resourceType: { type: String, default: () => '' },
    meta: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
};
</script>
